/* eslint-disable */
import AnnounceDetailView from "@/views/AnnounceDetailView.vue";
import AnnounceView from "@/views/AnnounceView.vue";
import CompnayView from "@/views/MyPageView.vue";
import HomeView from "@/views/HomeView.vue";
import LoginView from "@/views/LoginView.vue";
import MainView from "@/views/MainView.vue";
import NoticeDetailView from "@/views/NoticeDetailView.vue";
import NoticeView from "@/views/NoticeView.vue";
import privacyPolicyView from "@/views/PrivacyPolicyView.vue";
import signupView from "@/views/SignupView.vue";
import checkplus_success from "@/components/popup/checkplus_success.vue";

import CertificateApprovalView from "@/views/signup/CertificateApprovalView.vue";

// import NormalUserDetailView from "@/views/signup/NormalUserDetailView.vue";
// import TermsNormalView from "@/views/signup/TermsNormalView.vue";
// import TermsTotalView from "@/views/signup/TermsTotalView.vue";
// import CertificateRegistrationView from "@/views/signup/CertificateRegistrationView.vue";
// import TotalUserDetailView from "@/views/signup/TotalUserDetailView.vue";
// import UserTypeView from "@/views/signup/UserTypeView.vue";

import ResourceBoardView from "@/views/ResourceBoardView.vue";
import ResourceBoardDetailView from "@/views/ResourceBoardDetailView.vue";
import termsOfServiceView from "@/views/TermsOfServiceView.vue";
import { createRouter, createWebHistory } from "vue-router";

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "main",
      component: MainView,

      children: [
        { path: "login", name: "login", component: LoginView },
        { path: "home", name: "home", component: HomeView },
        { path: "company", name: "company", component: CompnayView },
        { path: "notice", name: "notice", component: NoticeView },
        { path: "noticeDetail/:seq", name: "noticeDetail", component: NoticeDetailView, props: true },
        { path: "announce", name: "announce", component: AnnounceView },
        { path: "announceDetail/:seq", name: "announceDetail", component: AnnounceDetailView },
        { path: "execution", name: "execution", component: CompnayView },
        { path: "mypage", name: "mypage", component: CompnayView },
        { path: "resourceBoard", name: "resourceBoard", component: ResourceBoardView },
        { path: "resourceBoardDetail/:seq", name: "resourceBoardDetail", component: ResourceBoardDetailView, props: true },
        { path: "termsOfService", name: "termsOfService", component: termsOfServiceView },
        { path: "privacyPolicy", name: "privacyPolicy", component: privacyPolicyView },
        { path: "signup", name: "signup", component: signupView },
        { path: "checkplus_success", name: "checkplus_success", component: checkplus_success },
        // { path: "signup/userType", name: "signUserType", component: UserTypeView, meta: { page: 1 } },
        // { path: "signup/terms/normal", name: "termsNormal", component: TermsNormalView, meta: { page: 2 } },
        // { path: "signup/normal/userDetails", name: "normalUserDetail", component: NormalUserDetailView, meta: { page: 3 } },
        // { path: "signup/terms/total", name: "termsTotal", component: TermsTotalView, meta: { page: 2 } },
        // { path: "signup/total/userDetails", name: "totalUserDetail", component: TotalUserDetailView, meta: { page: 3 } },
        // { path: "signup/certificateRegistration", name: "certificateRegistration", component: CertificateRegistrationView, meta: { page: 4 } },
        { path: "signup/certificateApproval", name: "certificateApproval", component: CertificateApprovalView, meta: { page: 5 } },
        // { path: "join", name: "join", component: UserTypeView, meta: { page: 2 } },
      ],
    },

    // {
    //   path: "/service/",
    //   name: "main",
    //   component: MainView,
    //   children: [{ path: "home", name: "home", component: HomeView }],
    // },
  ],
});
router.afterEach((to, from) => {
  document.querySelector(".contents")?.scrollTo({ top: 0, behavior: "auto" });
});
export default router;
